module.exports = __webpack_public_path__ + "static/media/ricochet.319483dd.png";